export const INTERNALS = [
    "/categoria",
    "/producto",
    "/combo",
    "/buscar",
    "/informacion",
    "/ofertas",
    "/oferta",
    "/servicios",
    "/ventas-mayoreo",
    "/sobre-nosotros",
    "/todos-los-productos",
    "/terminos-y-condiciones",
    "/comentarios-pedido",
  ];

  export const SUBINTERNALS = [
    "/categoria/",
    "/buscar/",
    "/producto/",
    "/combo/",
    "/oferta/",
    "/comentarios-pedido/",
  ];